// libs
import React from 'react';

import { Trans } from '@lyearn/i18n';
// components
import { Delete, Flip2 } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Checkbox, LinkButton, Typography } from '@lyearn/ui';

import { CertificateTemplateFragment } from '../../fragments/generated/CertificateTemplate';
// styles
import { certificateStyles } from './styles';

function CertificateCard({
  certificate,
  isSelected,
  className, // flex-shrink-0: safari fix - ui collapsing in some safari versions
  onSelect,
  onDelete,
  onReplace,
  disabled,
}: {
  certificate: CertificateTemplateFragment;
  isSelected?: boolean;
  className?: string;
  onSelect?: (certificateId: string) => void;
  onDelete?: () => void;
  onReplace?: () => void;
  disabled?: boolean;
}) {
  return (
    <Box
      className={cn(
        className ??
          cn(
            'mt-12 flex-shrink-0 rounded border py-20 ps-16 pe-24',
            isSelected ? 'border-focus-primary' : 'border-divider',
          ),
        'group',
        { 'cursor-pointer': !!onSelect },
      )}
      onClick={onSelect && !disabled ? () => onSelect(certificate.id) : undefined}>
      <Box className="flex flex-1 items-center justify-between">
        <Box className="flex">
          <Box
            className={cn(
              'h-48 flex-shrink-0 rounded-4 bg-cover me-16',
              certificateStyles(certificate.preview.url!),
            )}
          />
          <Box>
            <Typography color="text-text-primary" variant="label-01">
              {certificate.name}
            </Typography>
            <Typography className="mt-2" color="text-text-secondary" variant="body-short-02">
              <Trans
                i18nKey="Certificate:Form.CreatedBy"
                values={{
                  userName: certificate.createdBy?.name,
                }}
              />
            </Typography>
          </Box>
        </Box>
        <Box className="space-s-12">
          {onSelect ? (
            <Checkbox
              checked={isSelected}
              data-attr="SELECT"
              data-id={certificate.id}
              variant="circle"
            />
          ) : null}
          {onReplace ? (
            <LinkButton
              className="py-2 px-4 opacity-0 transition ease-in group-hover:opacity-100"
              color={'internal'}
              disabled={disabled}
              onClick={onReplace}>
              <Flip2 fillColorToken="icon-placeholder" />
            </LinkButton>
          ) : null}
          {onDelete ? (
            <LinkButton
              className="py-2 px-4 opacity-0 transition ease-in group-hover:opacity-100"
              color={'internal'}
              disabled={disabled}
              onClick={onDelete}>
              <Delete fillColorToken="icon-placeholder" />
            </LinkButton>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(CertificateCard);
